// extracted by mini-css-extract-plugin
export var callCard = "_ms-0";
export var callMessageButton = "_ms-1";
export var helpIcon = "_ms-3";
export var helpIconContainer = "_ms-4";
export var verticalDivider = "_ms-2";